import React from "react";
import { Navigate } from "react-router-dom";
function ServicesGallery() { return <Navigate replace to="/Services" />; }
export default ServicesGallery;
